var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewStructure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90911 5.00096H6.01172V3.20068H8.72161C8.82516 3.20068 8.90911 3.28464 8.90911 3.38818V5.00096Z",
    fill: "#3A7190"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46094 3.20068V5.00096H8.90961V3.38818C8.90961 3.28464 8.82566 3.20068 8.72211 3.20068H7.46094Z",
    fill: "#2B6181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01172 0C5.81752 0 5.66016 0.157359 5.66016 0.351562V4.64939C5.66016 4.84359 5.81752 5.00095 6.01172 5.00095C6.20592 5.00095 6.36328 4.84359 6.36328 4.64939V0.351562C6.36328 0.157359 6.20587 0 6.01172 0Z",
    fill: "#FF7043"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41797 4.29785H19.5811V23.0099H4.41797V4.29785Z",
    fill: "#FDEEDF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1328 4.29785H19.5815V23.0101H18.1328V4.29785Z",
    fill: "#F0D6C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 18.5918H16.3942V23.0103H7.60547V18.5918Z",
    fill: "#225069"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 18.5918H9.24731V23.0103H7.60547V18.5918Z",
    fill: "#B2EBF2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7529 18.5918H16.3948V23.0103H14.7529V18.5918Z",
    fill: "#B2EBF2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 5.89111H10.2131V8.3056H7.60547V5.89111Z",
    fill: "#FDEEDF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 10.0444H10.2131V12.4589H7.60547V10.0444Z",
    fill: "#FDEEDF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 14.2456H10.2131V16.6601H7.60547V14.2456Z",
    fill: "#FDEEDF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 5.89111H10.2131V8.3056H7.60547V5.89111Z",
    fill: "#B2EBF2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 10.0439H10.2131V12.4584H7.60547V10.0439Z",
    fill: "#B2EBF2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 14.2451H10.2131V16.6596H7.60547V14.2451Z",
    fill: "#B2EBF2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 5.89111H10.2131V8.3056H7.60547V5.89111Z",
    fill: "#B2EBF2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76465 5.89111H10.2133V8.3056H8.76465V5.89111Z",
    fill: "#80DEEA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 10.0444H10.2131V12.4589H7.60547V10.0444Z",
    fill: "#B2EBF2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76465 10.0444H10.2133V12.4589H8.76465V10.0444Z",
    fill: "#80DEEA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 14.2456H10.2131V16.6601H7.60547V14.2456Z",
    fill: "#B2EBF2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76465 14.2456H10.2133V16.6601H8.76465V14.2456Z",
    fill: "#80DEEA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 8.65721H10.2131C10.4073 8.65721 10.5646 8.49985 10.5646 8.30564V5.89111C10.5646 5.69691 10.4073 5.53955 10.2131 5.53955H7.60547C7.41127 5.53955 7.25391 5.69691 7.25391 5.89111V8.30564C7.25391 8.49985 7.41127 8.65721 7.60547 8.65721ZM7.95703 6.24272H9.86152V7.95413H7.95703V6.24272Z",
    fill: "#43809F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 12.81H10.2131C10.4073 12.81 10.5646 12.6527 10.5646 12.4585V10.0439C10.5646 9.84974 10.4073 9.69238 10.2131 9.69238H7.60547C7.41127 9.69238 7.25391 9.84974 7.25391 10.0439V12.4585C7.25391 12.6527 7.41127 12.81 7.60547 12.81ZM7.95703 10.3955H9.86152V12.1069H7.95703V10.3955Z",
    fill: "#43809F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 17.0112H10.2131C10.4073 17.0112 10.5646 16.8538 10.5646 16.6596V14.2451C10.5646 14.0509 10.4073 13.8936 10.2131 13.8936H7.60547C7.41127 13.8936 7.25391 14.0509 7.25391 14.2451V16.6596C7.25391 16.8538 7.41127 17.0112 7.60547 17.0112ZM7.95703 14.5967H9.86152V16.308H7.95703V14.5967Z",
    fill: "#43809F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3945 18.2397H7.60547C7.41141 18.2397 7.25391 18.3972 7.25391 18.5913V23.0097H7.95703V18.9429H16.043V23.0097H16.7461V18.5913C16.7461 18.3972 16.5886 18.2397 16.3945 18.2397Z",
    fill: "#2B6181"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9941 1.7627H21.4703C21.5738 1.7627 21.6578 1.84665 21.6578 1.9502V8.046C21.6578 8.14955 21.5738 8.2335 21.4703 8.2335H11.9941C11.8906 8.2335 11.8066 8.14955 11.8066 8.046V1.9502C11.8066 1.8466 11.8906 1.7627 11.9941 1.7627Z",
    fill: "#43809F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.209 1.7627V8.2335H21.4702C21.5737 8.2335 21.6577 8.14955 21.6577 8.046V1.9502C21.6577 1.84665 21.5737 1.7627 21.4702 1.7627H20.209Z",
    fill: "#3A7190"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2559 3.21143H20.2096V6.78485H13.2559V3.21143Z",
    fill: "#B2EBF2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7607 3.21143H20.2094V6.78485H18.7607V3.21143Z",
    fill: "#80DEEA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9941 10.189H21.4703C21.5738 10.189 21.6578 10.2729 21.6578 10.3765V16.4723C21.6578 16.5758 21.5738 16.6598 21.4703 16.6598H11.9941C11.8906 16.6598 11.8066 16.5758 11.8066 16.4723V10.3765C11.8066 10.2729 11.8906 10.189 11.9941 10.189Z",
    fill: "#43809F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.209 10.189V16.6598H21.4702C21.5737 16.6598 21.6577 16.5758 21.6577 16.4723V10.3765C21.6577 10.2729 21.5737 10.189 21.4702 10.189H20.209Z",
    fill: "#3A7190"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2559 11.6377H20.2096V15.2111H13.2559V11.6377Z",
    fill: "#B2EBF2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7607 11.6377H20.2094V15.2111H18.7607V11.6377Z",
    fill: "#80DEEA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2096 2.85986H13.2559C13.0617 2.85986 12.9043 3.01722 12.9043 3.21143V6.78484C12.9043 6.97905 13.0617 7.13641 13.2559 7.13641H20.2096C20.4038 7.13641 20.5611 6.97905 20.5611 6.78484V3.21143C20.5611 3.01722 20.4037 2.85986 20.2096 2.85986ZM19.858 6.43328H13.6074V3.56299H19.858V6.43328Z",
    fill: "#2B6181"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2096 11.2866H13.2559C13.0617 11.2866 12.9043 11.444 12.9043 11.6382V15.2116C12.9043 15.4058 13.0617 15.5632 13.2559 15.5632H20.2096C20.4038 15.5632 20.5611 15.4058 20.5611 15.2116V11.6382C20.5611 11.444 20.4037 11.2866 20.2096 11.2866ZM19.858 14.8601H13.6074V11.9898H19.858V14.8601Z",
    fill: "#2B6181"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71387 10.0441V18.4466C1.71387 18.6066 1.84357 18.7363 2.0036 18.7363H5.28729C5.44732 18.7363 5.57702 18.6066 5.57702 18.4466V10.0441C5.57702 9.8841 5.44732 9.75439 5.28729 9.75439H2.00365C1.84362 9.75439 1.71387 9.8841 1.71387 10.0441Z",
    fill: "#FF7043"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28759 9.75439H3.83887C3.9989 9.75439 4.1286 9.8841 4.1286 10.0441V18.4466C4.1286 18.6066 3.9989 18.7363 3.83887 18.7363H5.28754C5.44757 18.7363 5.57727 18.6066 5.57727 18.4466V10.0441C5.57732 9.8841 5.44762 9.75439 5.28759 9.75439Z",
    fill: "#FF5722"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01855 12.3276H4.27405C4.46826 12.3276 4.62562 12.1703 4.62562 11.9761C4.62562 11.7819 4.46826 11.6245 4.27405 11.6245H3.01855C2.82435 11.6245 2.66699 11.7819 2.66699 11.9761C2.66699 12.1703 2.82435 12.3276 3.01855 12.3276Z",
    fill: "#FFD180"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27405 13.0732H3.01855C2.82435 13.0732 2.66699 13.2306 2.66699 13.4248C2.66699 13.619 2.82435 13.7764 3.01855 13.7764H4.27405C4.46826 13.7764 4.62562 13.619 4.62562 13.4248C4.62562 13.2306 4.46821 13.0732 4.27405 13.0732Z",
    fill: "#FFD180"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2274 23.9999H0.772641C0.345937 23.9999 0 23.6539 0 23.2272C0 22.8005 0.345937 22.4546 0.772641 22.4546H23.2274C23.6541 22.4546 24 22.8005 24 23.2272C24 23.6539 23.6541 23.9999 23.2274 23.9999Z",
    fill: "#A35418"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.227 22.4546H21.7783C22.205 22.4546 22.551 22.8005 22.551 23.2272C22.551 23.6539 22.205 23.9999 21.7783 23.9999H23.227C23.6537 23.9999 23.9996 23.6539 23.9996 23.2272C23.9996 22.8005 23.6537 22.4546 23.227 22.4546Z",
    fill: "#8C4815"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewStructure);
export default __webpack_public_path__ + "static/media/new-structure.0a44115417fcff2c95fbe0f6a0614cfb.svg";
export { ForwardRef as ReactComponent };